import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TributacaoDadosCampos } from '../api/dto/tributacao-dados-campos';

@Injectable({
  providedIn: 'root'
})
export class ClassificacaoTributariaService {

    private url : string = UrlServidor.URL_BASE + 'classificacoes-tributarias';

    constructor(private http: HttpClient){}

    obterDadosCamposTributacao(): Observable<TributacaoDadosCampos> {

      return this.http.get<TributacaoDadosCampos>(`${this.url}/dados-campos`);
    }

}
